import styled from 'styled-components';

const StyledValidatedTextArea = styled.div`
  width: 100%;
  margin-bottom: 4px;
`;

export default StyledValidatedTextArea;
